// src/components/WavyDivider.js
import React from 'react';

// Define multiple wave path data strings for variety
const wavePaths = [
  "M0,50 Q250,0 500,15 T750,60 T1000,50 L1000,100 L0,100 Z", // Gentle complex
  "M0,30 Q150,70 300,30 T600,40 T900,30 T1000,35 L1000,100 L0,100 Z", // Rippled
  "M0,60 C200,0 300,0 500,30 S800,60 1000,50 L1000,100 L0,100 Z", // Smoother Curve
];

// Helper function to get a consistent wave based on an index
const getWavePath = (index) => {
    return wavePaths[index % wavePaths.length];
}

function WavyDivider({
  bgColor = 'transparent', // Background color of the container (section above)
  fillColor,              // Fill color of the wave (BG of section below)
  height = 'var(--wave-height)',
  waveIndex = 0,          // Index to pick a wave shape
  direction = 'down',     // 'down' (normal) or 'up' (flipped)
}) {
  const pathData = getWavePath(waveIndex);

  const containerStyle = {
    backgroundColor: bgColor,
    lineHeight: 0, // Prevent extra space
    position: 'relative', // Allows z-index control if needed later
    transform: direction === 'up' ? 'scaleY(-1)' : 'scaleY(1)',
  };

  const svgStyle = {
    display: 'block',
    width: '100%',
    height: `calc(${height})`, // Use CSS variable or passed height
    color: fillColor, // Sets the fill color via currentColor
  };

  return (
    <div className="wavy-divider-container" style={containerStyle}>
      <svg
        viewBox="0 0 1000 100" // ViewBox defines the internal coordinate system
        preserveAspectRatio="none" // Allows stretching
        style={svgStyle}
      >
        <path d={pathData} fill="currentColor" />
      </svg>
    </div>
  );
}

export default WavyDivider;